import {
    ASSET_TYPES_FETCHING,
    ASSET_TYPES_FETCHING_FAILURE,
    ASSET_TYPES_FETCHING_SUCCESS,
} from '../actions/types'

const INITIAL_STATE = {
    items: {},
    fetching: false,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ASSET_TYPES_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case ASSET_TYPES_FETCHING_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        case ASSET_TYPES_FETCHING_SUCCESS:
            return {
                ...state,
                fetching: false,
                items: prepareItems(action.payload),
            }

        default:
            return state
    }
}

const prepareItems = items => {
    const result = {}

    for (let i = 0; i < items.length; i++) {
        const el = items[i]
        result[el.value] = el.name
    }

    return result
}

export default reducer
